export interface LevelConfig {
  tutorialCutscene?: string;
  tilemapKey: string;
  tilemapJSON: string;
  tilesets: {
    name: string;
    path: string;
  }[];
  layers: string[];
  collisionLayers?: string[]; // Add this to specify which layers have collision
  objectLayers: {
    name: string;
    spritesheetKey: string;
    tilesetName: string;
  }[];
}

export interface LevelConfigMap {
  [level: number]: LevelConfig;
}

// TODO: Lach - should this define all level data and not just tilemaps?
// I will add some level data now.

export const levelConfigs: LevelConfigMap = {
  1: {
    tutorialCutscene: 'overview-cutscene-1', // put at start of realms
    tilemapKey: 'level1-tilemap',
    tilemapJSON: '/game_assets/tilemaps/forest-biome-1.json',
    tilesets: [
      {
        name: 'summer forest',
        path: '/game_assets/tilemaps/images/summer forest.png',
      },
      {
        name: 'summer 32x32',
        path: '/game_assets/tilemaps/images/summer 32x32.png',
      },
      {
        name: 'summer trees 80x112',
        path: '/game_assets/tilemaps/images/summer trees 80x112.png',
      },
      // {
      //   name: 'collision',
      //   path: '/game_assets/tilemaps/images/collision & alpha.png',
      // },
    ],
    layers: [
      'Ground 1 - summer forest',
      'Some tree bits - summer forest',
      'Details - summer forest',
      'TOP covering foliage - summer forest',
      'COLLISION',
    ],
    collisionLayers: ['COLLISION'], // This layer is used for collision

    objectLayers: [
      {
        name: 'Trees - summer trees 80x112',
        spritesheetKey: 'summer-trees-80-112-spritesheet',
        tilesetName: 'summer trees 80x112',
      },
      {
        name: 'Extra bushes - summer 32x32',
        spritesheetKey: 'summer-32-32-spritesheet',
        tilesetName: 'summer 32x32',
      },
      {
        name: 'TOP trees - summer trees 80x112',
        spritesheetKey: 'summer-trees-80-112-spritesheet',
        tilesetName: 'summer trees 80x112',
      },
    ],
  },
  2: {
    tutorialCutscene: 'overview-cutscene-2', // put at start of realm
    tilemapKey: 'level2-tilemap',
    tilemapJSON: '/game_assets/tilemaps/forest-biome-2.json',
    tilesets: [
      {
        name: 'summer forest',
        path: '/game_assets/tilemaps/images/summer forest.png',
      },
      {
        name: 'summer 32x32',
        path: '/game_assets/tilemaps/images/summer 32x32.png',
      },
      {
        name: 'summer trees 80x112',
        path: '/game_assets/tilemaps/images/summer trees 80x112.png',
      },
      // {
      //   name: 'collision',
      //   path: '/game_assets/tilemaps/images/collision & alpha.png',
      // },
    ],
    layers: [
      'Ground - summer forest',
      'Objects 1 - summer forest',
      'Objects 2 - summer 32x32',
      'TOP - summer forest',
      'Ground deco - summer forest',
      'COLLISION',
    ],
    collisionLayers: ['COLLISION'], // This layer is used for collision
    objectLayers: [
      {
        name: 'Back trees - summer trees 80x112',
        spritesheetKey: 'summer-trees-80-112-spritesheet',
        tilesetName: 'summer trees 80x112',
      },
      {
        name: 'TOP bushes and logs - summer 32x32',
        spritesheetKey: 'summer-32-32-spritesheet',
        tilesetName: 'summer 32x32',
      },
      {
        name: 'TOP trees - summer trees 80x112',
        spritesheetKey: 'summer-trees-80-112-spritesheet',
        tilesetName: 'summer trees 80x112',
      },
    ],
  },
  3: {
    tilemapKey: 'level3-tilemap',
    tilemapJSON: '/game_assets/tilemaps/forest-biome-3.json',
    tilesets: [
      {
        name: 'summer 16x32',
        path: '/game_assets/tilemaps/images/summer 16x32.png',
      },
      {
        name: 'summer 48x32',
        path: '/game_assets/tilemaps/images/summer 48x32.png',
      },
      {
        name: 'summer forest wang tiles',
        path: '/game_assets/tilemaps/images/summer forest wang tiles.png',
      },
      {
        name: 'summer trees 80x112',
        path: '/game_assets/tilemaps/images/summer trees 80x112.png',
      },
      {
        name: 'summer forest',
        path: '/game_assets/tilemaps/images/summer forest.png',
      },
      {
        name: 'summer 32x32',
        path: '/game_assets/tilemaps/images/summer 32x32.png',
      },
      // {
      //   name: 'collision',
      //   path: '/game_assets/tilemaps/images/collision & alpha.png',
      // },
    ],
    layers: [
      'Ground - summer forest wang tiles',
      'summer details 1 - summer 48x32',
      'Ground details 2 - summer forest',
      'Back trees - summer trees 80x112',
      'Shrubbery 1 - summer forest',
      'Shrubbery 2 - summer 16x32',
      'Shrubbery 3 - summer 32x32',
      'Cliffs shadows - summer forest',
      'Cliffs - summer forest',
      'TOP details - summer forest',
      'COLLISION',
    ],
    collisionLayers: ['COLLISION'], // This layer is used for collision
    objectLayers: [
      {
        name: 'extra mushrooms - summer forest',
        spritesheetKey: 'summer-forest-spritesheet',
        tilesetName: 'summer forest',
      },
      {
        name: 'Extra bushes - summer 32x32',
        spritesheetKey: 'summer-32-32-spritesheet',
        tilesetName: 'summer 32x32',
      },
      {
        name: 'TOP trees - summer trees 80x112',
        spritesheetKey: 'summer-trees-80-112-spritesheet',
        tilesetName: 'summer trees 80x112',
      },
    ],
  },
  4: {
    tilemapKey: 'level4-tilemap',
    tilemapJSON: '/game_assets/tilemaps/forest-biome-4.json',
    tilesets: [
      {
        name: 'summer forest',
        path: '/game_assets/tilemaps/images/summer forest.png',
      },
      {
        name: 'summer 32x32',
        path: '/game_assets/tilemaps/images/summer 32x32.png',
      },
      {
        name: 'summer trees 80x112',
        path: '/game_assets/tilemaps/images/summer trees 80x112.png',
      },
      // {
      //   name: 'collision',
      //   path: '/game_assets/tilemaps/images/collision & alpha.png',
      // },
    ],
    layers: [
      'Terrain - summer forest',
      'Cliffs - summer forest',
      'Cliff shadows - summer forest',
      'objects - summer forest',
      'TOP cliff shadows - summer forest',
      'TOP cliffs and foliage - summer forest',
      'TOP on-cliff deco - summer forest',
      'COLLISION',
    ],
    collisionLayers: ['COLLISION'], // This layer is used for collision
    objectLayers: [
      {
        name: 'Back trees - summer trees 80x112',
        spritesheetKey: 'summer-trees-80-112-spritesheet',
        tilesetName: 'summer trees 80x112',
      },
      {
        name: 'TOP trees - summer trees 80x112',
        spritesheetKey: 'summer-trees-80-112-spritesheet',
        tilesetName: 'summer trees 80x112',
      },
    ],
  },
  5: {
    tilemapKey: 'level5-tilemap',
    tilemapJSON: '/game_assets/tilemaps/forest-biome-5.json',
    tilesets: [
      {
        name: 'summer forest wang tiles',
        path: '/game_assets/tilemaps/images/summer forest wang tiles.png',
      },
      {
        name: 'summer 16x32',
        path: '/game_assets/tilemaps/images/summer 16x32.png',
      },
      {
        name: 'summer 48x32',
        path: '/game_assets/tilemaps/images/summer 48x32.png',
      },
      {
        name: 'summer trees 80x112',
        path: '/game_assets/tilemaps/images/summer trees 80x112.png',
      },
      {
        name: 'summer forest',
        path: '/game_assets/tilemaps/images/summer forest.png',
      },
      {
        //no tileset exists?
        name: 'bonus bridge',
        path: '/game_assets/tilemaps/images/bonus bridge.png',
      },
      // {
      //   name: 'collision',
      //   path: '/game_assets/tilemaps/images/collision & alpha.png',
      // },
    ],
    layers: [
      'Terrain - summer forest wang tiles',
      'Bridges - bonus bridge',
      //no tileset loaded
      'Sparkles - summer water sparkles B',
      'Foliage - summer 16x32',
      'Foliage 2 - summer forest',
      'Cliffs shadow - summer forest',
      'Cliffs - summer forest',
      'Objects 1 - summer forest',
      'Objects 2 - summer 48x32',
      'Objects 3 - summer 16x32',
      'TOP foliage - summer trees',
      'COLLISION',
    ],
    collisionLayers: ['COLLISION'], // This layer is used for collision
    objectLayers: [
      {
        name: 'TOP trees - summer trees',
        spritesheetKey: 'summer-trees-80-112-spritesheet',
        tilesetName: 'summer trees 80x112',
      },
    ],
  },
  6: {
    tilemapKey: 'level6-tilemap',
    tilemapJSON: '/game_assets/tilemaps/forest-biome-6.json',
    tilesets: [
      {
        name: 'summer forest',
        path: '/game_assets/tilemaps/images/summer forest.png',
      },
      {
        name: 'summer forest wang tiles',
        path: '/game_assets/tilemaps/images/summer forest wang tiles.png',
      },
      {
        name: 'summer trees 80x112',
        path: '/game_assets/tilemaps/images/summer trees 80x112.png',
      },
      {
        name: 'summer 32x32',
        path: '/game_assets/tilemaps/images/summer 32x32.png',
      },
      {
        name: 'summer 16x32',
        path: '/game_assets/tilemaps/images/summer 16x32.png',
      },
      {
        name: 'summer water sparkles B',
        path: '/game_assets/tilemaps/images/summer water sparkles B 16x16.png',
      },
      // {
      //   name: 'collision',
      //   path: '/game_assets/tilemaps/images/collision & alpha.png',
      // },
    ],
    layers: [
      'terrain - summer forest wang tiles',
      'Sparkles - summer water sparkles B',
      'deco 1 - summer forest',
      'TOP foliage - summer forest 16x32',
      'COLLISION',
    ],
    collisionLayers: ['COLLISION'], // This layer is used for collision
    objectLayers: [
      {
        name: 'TOP rocks - summer 32x32',
        spritesheetKey: 'summer-32-32-spritesheet',
        tilesetName: 'summer 32x32',
      },
      {
        name: 'TOP trees - summer trees 80x112',
        spritesheetKey: 'summer-trees-80-112-spritesheet',
        tilesetName: 'summer trees 80x112',
      },
    ],
  },
  7: {
    tilemapKey: 'level7-tilemap',
    tilemapJSON: '/game_assets/tilemaps/forest-biome-7.json',
    tilesets: [
      {
        name: 'summer trees 80x112',
        path: '/game_assets/tilemaps/images/summer trees 80x112.png',
      },
      {
        name: 'spring trees 80x112',
        path: '/game_assets/tilemaps/images/spring trees 80x112.png',
      },
      {
        name: 'summer forest',
        path: '/game_assets/tilemaps/images/summer forest.png',
      },
      {
        name: 'summer forest wang tiles',
        path: '/game_assets/tilemaps/images/summer forest wang tiles.png',
      },
      {
        name: 'summer 16x32',
        path: '/game_assets/tilemaps/images/summer 16x32.png',
      },
      {
        name: 'summer waterfall B',
        path: '/game_assets/tilemaps/images/summer waterfall B 16x16.png',
      },
      {
        name: 'summer water sparkles B',
        path: '/game_assets/tilemaps/images/summer water sparkles B 16x16.png',
      },
      {
        name: 'bonus bridge',
        path: '/game_assets/tilemaps/images/bonus bridge.png',
      },
      //this probably isn't the right way :)
      // {
      //   name: 'collision',
      //   path: '/game_assets/tilemaps/images/collision & alpha.png',
      // },
    ],
    layers: [
      'Terrain - summer forset wang tiles',
      'deco 1 - summer forest',
      'deco hole over - summer forest',
      'deco 2 - summer 16x32',
      'Waterfalls - summer waterfall B',
      'Waterfall splash - summer waterfall B',
      'Sparkles - summer water sparkles B',
      'pink tree - spring trees 80x112',
      'TOP foliage - summer forest',
      'COLLISION',
    ],
    collisionLayers: ['COLLISION'], // This layer is used for collision

    objectLayers: [
      {
        name: 'bridge - bonus bridge',
        spritesheetKey: 'bonus-bridge-spritesheet',
        tilesetName: 'bonus bridge',
      },
      {
        name: 'TOP trees - summer trees 80x112',
        spritesheetKey: 'summer-trees-80-112-spritesheet',
        tilesetName: 'summer trees 80x112',
      },
    ],
  },
};
